import { ChangeDetectorRef, Directive, Input, OnChanges, OnInit, inject } from '@angular/core';

import { ThemeInverse, getByThemeOrDefault, injectCurrentTheme } from '@frontend/sports/common/ui/shared';
import { DsNotificationBubble, DsNotificationBubbleVariant } from '@frontend/ui/notification-bubble';

import { ThemeNotificationSize, ThemeNotificationVariant } from './types';

@Directive({
    selector: '[msThemedNotification]',
})
export class SportsThemedNotificationDirective implements OnInit, OnChanges {
    @Input() themedSize?: ThemeNotificationSize;
    @Input() themedVariant?: ThemeNotificationVariant;
    @Input() themeInverse?: ThemeInverse;
    @Input() selectedVariant?: ThemeNotificationVariant;
    @Input() isSelected = false;
    currentTheme = injectCurrentTheme();
    changeRef: ChangeDetectorRef = inject(ChangeDetectorRef);
    notification: DsNotificationBubble = inject(DsNotificationBubble, {
        self: true,
    });

    ngOnInit(): void {
        const size = this.themedSize?.[this.currentTheme];
        if (size) {
            this.notification.size.set(size);
        }

        const themeInverse = this.themeInverse?.[this.currentTheme];
        if (themeInverse) {
            this.notification.inverse.set(themeInverse.isInverse);
        }
    }

    ngOnChanges() {
        const variant = this.themeVariant;
        if (variant) {
            this.notification.variant.set(variant);
        }
    }

    get themeVariant(): DsNotificationBubbleVariant | undefined {
        return this.isSelected && this.selectedVariant
            ? getByThemeOrDefault(this.selectedVariant, this.currentTheme)
            : this.themedVariant
              ? getByThemeOrDefault(this.themedVariant, this.currentTheme)
              : undefined;
    }
}
